import React from 'react'

import speedButton0 from '@assets/speed-button-0.svg'
import speedButton1 from '@assets/speed-button-1.svg'
import speedButton2 from '@assets/speed-button-2.svg'

import smallSpeedButton0 from '@assets/speed-button-small-enabled-0.svg'
import smallSpeedButton1 from '@assets/speed-button-small-enabled-1.svg'
import smallSpeedButton2 from '@assets/speed-button-small-enabled-2.svg'
import smallSpeedButton3 from '@assets/speed-button-small-enabled-3.svg'

import smallSpeedButtonEQ0 from '@assets/jackpot-eq/speed-button-small-enabled-0.svg'
import smallSpeedButtonEQ1 from '@assets/jackpot-eq/speed-button-small-enabled-1.svg'
import smallSpeedButtonEQ2 from '@assets/jackpot-eq/speed-button-small-enabled-2.svg'
import smallSpeedButtonEQ3 from '@assets/jackpot-eq/speed-button-small-enabled-3.svg'

import { withAutoBlur } from '../../../utils/misc'
import { GameUIMessageType, SpeedClickedMessage } from 'game-ui-types'
import { useConfigurationStore, useJackpotStore } from '@stores'
import { cn } from '@amusnet/react-ui'

interface SpeedButtonProps {
    isActive: boolean
    speedLevel: number
}

const SpeedButton: React.FC<SpeedButtonProps> = ({ isActive, speedLevel }) => {
    const isEQJackpotType = useJackpotStore((state) => state.isEQJackpotType)
    const shouldEnableUltraSpeed = useConfigurationStore((state) => state.shouldEnableUltraSpeed)

    const normalTextures = [speedButton0, speedButton1, speedButton2]
    const ultraSpeedTextures = !isEQJackpotType
        ? [smallSpeedButton0, smallSpeedButton1, smallSpeedButton2, smallSpeedButton3]
        : [smallSpeedButtonEQ0, smallSpeedButtonEQ1, smallSpeedButtonEQ2, smallSpeedButtonEQ3]

    const textures = shouldEnableUltraSpeed ? ultraSpeedTextures : normalTextures

    const index = Math.min(speedLevel, textures.length - 1)
    const speedButtonSrc = textures[index]

    const handleSpeedButtonClicked = withAutoBlur(() => {
        const speedClickedMessage: SpeedClickedMessage = {
            type: GameUIMessageType.SPEED_CLICKED,
        }

        window.postMessage(speedClickedMessage)
    })

    return (
        <button
            id="speed-button"
            className={cn('w-[110px] h-[58px] focus:outline-none', !isActive && 'opacity-50 pointer-events-none')}
            onClick={(e) => handleSpeedButtonClicked(e)}
        >
            <img src={speedButtonSrc} alt="Speed Button" className="w-full h-full" />
        </button>
    )
}

export default SpeedButton
